module.exports = __webpack_public_path__ + "static/media/red_coin.e0ed0cbf.png";